import { computed } from 'vue'
import { useJobStore } from '@/manage/stores/job'
import { isDraftJob } from '@/manage/utils/job'

export type JobOption = {
  id: string
  name: string
}

const mapJobToOption = (job: { id?: string | null; name?: string | null; uname?: string | null }) => ({
  id: String(job?.id || '').trim(),
  name: String(job?.name || job?.uname || '').trim(),
})

export const useJobOptions = () => {
  const jobStore = useJobStore()

  const projectOptions = computed<JobOption[]>(() =>
    jobStore.jobs
      .filter((job) => !isDraftJob(job))
      .map(mapJobToOption)
      .filter((job) => job.id && job.name),
  )

  const openProjectOptions = computed<JobOption[]>(() =>
    jobStore.jobs
      .filter((job) => !job.close_at && !isDraftJob(job))
      .map(mapJobToOption)
      .filter((job) => job.id && job.name),
  )

  const ensureJobsLoaded = async () => jobStore.fetchJobs()

  return {
    projectOptions,
    openProjectOptions,
    ensureJobsLoaded,
  }
}
